import React from 'react';
import postData from './postData';
import useData from './useData';

const useForm = (getUrl, postUrl, initialData) => {

    const init = initialData && JSON.parse(JSON.stringify(initialData));

    const { isLoaded, data, setData, setUrl, fetchData } = useData(getUrl, init);

    const addErrors = (errors) => {
        const currentData = JSON.parse(JSON.stringify(data));
        for (const prop in currentData.item) {
            if (Object.prototype.hasOwnProperty.call(currentData.item, prop)) {
                currentData.item[`${prop}_error`] = undefined;
                const propertyName = prop[0].toUpperCase() + prop.substring(1);
                const propertyErrors = errors[`Item.${propertyName}`];
                if (propertyErrors !== undefined) {
                    currentData.item[`${prop}_error`] = propertyErrors[0];
                }
            }
        }
        currentData.item.errors = errors;
        setData(currentData);
    }

    const submitData = (successCallback, validator) => {
        const currentData = JSON.parse(JSON.stringify(data));
        if (validator && Object.prototype.toString.call(validator) === '[object Function]') {
            if (!validator(currentData.item)) {
                setData(currentData);
                return;
            }
        }
        postData(postUrl, { item: currentData.item }, successCallback, addErrors);
    };

    function formChange({ target: { name, type, value, checked } }) {
        const currentData = JSON.parse(JSON.stringify(data));

        if (currentData.item) {
            if (type === 'checkbox') {
                currentData.item[name] = checked;
            } else if (type === 'number') {
                currentData.item[name] = parseFloat(value);
            } else {
                currentData.item[name] = value;
            }
        }

        setData(currentData);
    }

    return {
        data: data,
        item: data.item,
        formChange: formChange,
        isLoaded: isLoaded,
        setData: setData,
        setUrl: setUrl,
        submitData: submitData,
        reset: fetchData
    }
}

export default useForm;